module.exports = __webpack_public_path__ + "img/R_SEC_W.84d376a9.svg";